export default "__VITE_ASSET__CBp$eYYB__"